import {
  isHealthKitAvailable,
  queryHealthKitDailySummary,
  queryHealthKitSleep,
  queryHealthKitWorkouts,
  queryHealthKitHeartRate,
  queryHealthKitBodyMeasurements,
} from '../utils/capacitor';
import { apiService } from './api';

function getTodayDateString(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function getYesterdayDateString(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export async function syncHealthKitData(garminConnected = false): Promise<boolean> {
  const available = await isHealthKitAvailable();
  if (!available) return false;

  const today = getTodayDateString();
  const yesterday = getYesterdayDateString();

  try {
    // Query sleep for both today and yesterday — sleep sessions typically span midnight
    const [daily, sleepToday, sleepYesterday, heartRate, workouts, bodyMeasurements] = await Promise.all([
      queryHealthKitDailySummary(today),
      queryHealthKitSleep(today, garminConnected),
      queryHealthKitSleep(yesterday, garminConnected),
      queryHealthKitHeartRate(today),
      queryHealthKitWorkouts(yesterday, today, garminConnected),
      queryHealthKitBodyMeasurements(),
    ]);

    // Use today's sleep if available, fall back to yesterday's (covers midnight-crossing sessions)
    const sleep = (sleepToday && sleepToday.totalSleepSeconds > 0) ? sleepToday : sleepYesterday;

    await apiService.syncHealthKit({
      daily: daily || undefined,
      sleep: sleep || undefined,
      heartRate: heartRate || undefined,
      workouts: workouts?.length ? workouts : undefined,
      bodyMeasurements: bodyMeasurements || undefined,
    });

    return true;
  } catch (err) {
    console.error('HealthKit sync failed:', err);
    return false;
  }
}
